import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator cuts it to shape and reads which way it points. */
export const FishScalePatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="fishscale"
    width={{ value: "12.4", min: 5, max: 30, labelKey: "TILE_WIDTH" }}
    height={{ value: "11", min: 5, max: 30, labelKey: "TILE_HEIGHT" }}
  />
);
